import React, { useState, useEffect, useRef } from "react";
import { ThemeCtx, ToastCtx, api, SEV_C, STAT_C, PAGE_SIZE, Pager, Card, Modal, Bdg, Dot, Av, AdminBadge, useToast, ConfirmDialog, usePagination } from "../shared.js";

export function PageAgentStatus(){
  var T=React.useContext(ThemeCtx).T;
  var _a=useState([]); var agents=_a[0]; var setAgents=_a[1];
  useEffect(function(){
    api.get("/agent/status").then(function(d){setAgents([{name:"AI Agent",status:d.configured?"Active":"Idle",provider:d.provider}]);}).catch(function(){});
  }, []);
  var sc={Active:T.success,Idle:T.warning,Error:T.danger};
  return React.createElement(Card,null,
    React.createElement("div",{style:{fontSize:13,fontWeight:600,color:T.text,marginBottom:12}},"Agent Status"),
    agents.map(function(a){
      return React.createElement("div",{key:a.name,style:{display:"flex",alignItems:"center",gap:10,padding:"10px 0"}},
        React.createElement(Dot,{c:sc[a.status]||T.text3}),
        React.createElement("span",{style:{flex:1,fontSize:13,color:T.text}},a.name),
        React.createElement(Bdg,{t:a.status,c:sc[a.status]||T.text3}),
        a.provider&&React.createElement("span",{style:{fontSize:11,color:T.text3}},a.provider)
      );
    })
  );
}



